// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  worldId: __t.u64().name("world_id"),
  sectorId: __t.u64().name("sector_id"),
  side: __t.string(),
  state: __t.string(),
  stateAt: __t.timestamp().name("state_at"),
  lockUntil: __t.timestamp().name("lock_until"),
  leaveAt: __t.timestamp().name("leave_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
